import {THEME_TYPE} from '../Types/CommonTypes';

/**
 * Recursively merges two objects of THEME_TYPE structure.
 * Overrides only keys that exist in the second object.
 *
 * @param obj1 - The base THEME_TYPE object
 * @param obj2 - The THEME_TYPE object that overrides values in obj1
 * @returns A new THEME_TYPE object
 */
export const mergeThemes = (
  obj1: THEME_TYPE,
  obj2: Partial<THEME_TYPE>,
): THEME_TYPE => {
  const result: any = {...obj1}; // Create a shallow copy of the base object

  for (const key in obj2) {
    if (obj2.hasOwnProperty(key)) {
      if (
        typeof obj2[key] === 'object' &&
        obj2[key] !== null &&
        !Array.isArray(obj2[key])
      ) {
        // Recursively merge nested objects like colors and fonts
        result[key] = mergeThemes(obj1[key], obj2[key]);
      } else {
        // Override the value from obj2
        result[key] = obj2[key];
      }
    }
  }

  return result as THEME_TYPE;
};
